import { Form } from 'factorial-form'
import _ from 'lodash'

class PolicyForm extends Form {
  constructor(values: Record<string, any>) {
    super(values, {
      name: 'string',
      starts_on: 'date',
      recurrence: 'string',
      periodicity: 'string',
      default: 'boolean',
      company_id: 'string',
      country: 'string',
      currency: 'string',
    })
  }

  get policyData(): Record<string, any> {
    const data = this.data()

    const attrs = _.pick(data, [
      'id',
      'name',
      'starts_on',
      'recurrence',
      'default',
      'company_id',
      'country',
      'currency',
    ])

    return { ...attrs }
  }
}

export default PolicyForm
